import { configureStore } from '@reduxjs/toolkit';

import authReducer from './auth';
import calendarReducer from './calendar';
import unitsReducer from './units';
import categoryReducer from './category';
import courseReducer from './course';
import locationReducer from './location';
import zoomReducer from './zoom';
import searchReducer from './search';
import modalReducer from './modal';
import discussionReducer from './discussion';
import messagesReducer from './messages';
import settingAccountReducer from './settingAccount';
import settingsReducer from './settings';
import cartReducer from './cart';
import GlobalReducer from './global';
import MasterReducer from './master';
import DetailPageReducer from './detailPage';
import aimodalReducer from './ai-modal';
import ltiReducer from './lti';

export default configureStore({
  reducer: {
    auth: authReducer,
    calendar: calendarReducer,
    units: unitsReducer,
    categories: categoryReducer,
    courses: courseReducer,
    location: locationReducer,
    zoom: zoomReducer,
    search: searchReducer,
    modal: modalReducer,
    discussion: discussionReducer,
    messages: messagesReducer,
    settingAccount: settingAccountReducer,
    settings: settingsReducer,
    carts: cartReducer,
    global: GlobalReducer,
    master: MasterReducer,
    detailPage: DetailPageReducer,
    aimodal: aimodalReducer,
    lti: ltiReducer,
  },
  devTools: true,
});
